import { GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED } from '@common/neo.tax';

import { stringifyCsv } from '@neo.tax/shared';

const headers = Object.values(GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED);
export const HEADERS_STRINGIFIED = stringifyCsv([headers]);

const exampleData = [
  headers,
  [
    'Maya Angelou',
    'Chief Editor',
    'Marketing',
    'mangelou@example.com',
    '60,000.00',
    '5,000.00',
    'United States',
    'maya-employee-id',
    'mikasa-employee-id',
    '5/15/23',
    '',
    '1101 - R&D',
    '',
  ],
  [
    'Louis Armstrong',
    'Backend Engineer',
    'Software Development',
    'larmstrong@example.com',
    '115,000.00',
    '5,000.00',
    'United States',
    'louis-employee-id',
    'thomas-employee-id',
    '1/1/22',
    '12/15/23',
    '1101 - R&D',
    'France Holding Co',
  ],
  [
    'Reiner Braun',
    'UI/UX Designer',
    'Design',
    'rbraun@example.com',
    '215,000.00',
    '10,000.00',
    'United States',
    'reiner-employee-id',
    '',
    '1/1/22',
    '',
    '1101 - R&D',
    'Manufacturing LLC',
  ],
  [
    'Mikasa Ackerman',
    'Marketing Director',
    'Marketing',
    'mackerman@example.com',
    '84,000.00',
    '4,000.00',
    'United States',
    'mikasa-employee-id',
    '',
    '1/1/22',
    '',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Johann Bach',
    'Frontend Engineer',
    'Software Development',
    'jbach@example.com',
    '84,300.00',
    '64,300.00',
    'United States',
    'johann-employee-id',
    'thomas-employee-id',
    '1/1/22',
    '',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Rakhshaan Adamjee',
    'CFO',
    'Finance',
    'radamjee@example.com',
    '110,000.00',
    '220,000.00',
    'United States',
    'rakhshaan-employee-id',
    '',
    '1/1/22',
    '',
    '1101 - R&D',
    'US Corporate',
  ],
  [
    'Joshua Zhou',
    'Product Manager',
    'Product Development',
    'jzhou@example.com',
    '150,000.00',
    '50,000.00',
    'United States',
    'joshua-employee-id',
    '',
    '9/1/18',
    '8/1/22',
    '1204 - Data',
    'US Corporate',
  ],
  [
    'Darlene Snell',
    'Software Engineer',
    'Software Development',
    'dsnell@example.com',
    '95,000.00',
    '905,000.00',
    'United States',
    'darlene-employee-id',
    'thomas-employee-id',
    '8/8/19',
    '4/1/23',
    '1204 - Data',
    'US Corporate',
  ],
  [
    'Zoro Roronoa',
    'Sales',
    'Sales',
    'zroronoa@example.com',
    '65,600.00',
    '690.00',
    'United States',
    'zoro-employee-id',
    '',
    '10/2/19',
    '',
    '1204 - Data',
    'US Corporate',
  ],
  [
    'Alexander Hamilton',
    'Customer Success',
    'Customer Success',
    'ahamilton@example.com',
    '74,300.00',
    '4,800.00',
    'United States',
    'alexander-employee-id',
    '',
    '',
    '',
    '303 - Intel',
    '',
  ],
  [
    'Gon Freecss',
    'Project Manager',
    'Product Development',
    'gfreecss@example.com',
    '145,600.00',
    '192,200.00',
    'United States',
    'gon-employee-id',
    'joshua-employee-id',
    '',
    '',
    '303 - Intel',
    '',
  ],
  [
    'Thomas Bruner',
    'VP of Engineering',
    'Software Development',
    'tbruner@example.com',
    '162,500.00',
    '500,000.00',
    'United States',
    'thomas-employee-id',
    '',
    '',
    '',
    '303 - Intel',
    '',
  ],
  [
    'Leah Smith',
    'Software Developer',
    'Software Development',
    'lsmith@example.com',
    '112,500.00',
    '0.00',
    'United States',
    'leah-employee-id',
    'thomas-employee-id',
    '',
    '',
    '104 - Ops',
    '',
  ],
  [
    'Leila Mogler',
    'Graphic Designer',
    'Marketing',
    'lmogler@example.com',
    '79,500.00',
    '0.00',
    'United Kingdom',
    'leila-employee-id',
    'mikasa-manager-employee-id',
    '',
    '',
    '104 - Ops',
    '',
  ],
];

export const EXAMPLE_DATA_STRINGIFIED = stringifyCsv(exampleData);
